import request from '@/utils/request'

// 分页查询文件
export function getFilePage(params) {
  return request({
    url: '/v3/scs/file/page',
    method: 'post',
    data: params
  })
}

// 产品列表
export function getProList() {
  return request({
    url: '/v3/scs/product/list',
    method: 'post',
    data: {}
  })
}

// 上传文件
export function uploadFile(file, dtoJson) {
  let formData = new FormData()
  formData.append('file', file.raw)
  formData.append('dtoJson', JSON.stringify(dtoJson))
  return request({
    url: '/v3/scs/file/upload',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: formData
  })
}